import { ApiResponse } from "types/apiTypes";
import { ClassLevel, ClassLevelSearchParams } from "types/classLevelTypes";
import axiosInstance from "./axiosInstance";



/**
 * Search subject coefficients with optional parameters
 */
export const getAllSubjectCoefficientsByClassLevel = async (params: ClassLevelSearchParams): Promise<ClassLevel[]> => {
  const response = await axiosInstance.get<ApiResponse<ClassLevel[]>>("/subject-coefficients", { params });
  return response.data.data;
};


export const createSubjectCoefficient = async (subjectCoefficient: ClassLevel) => {
  const response = await axiosInstance.post<ApiResponse<ClassLevel>>("/subject-coefficients", subjectCoefficient);
  return response.data.data;
};



export const deleteSubjectCoefficient = async (id: string) => {
  const response = await axiosInstance.delete<ApiResponse<ClassLevel>>(`/subject-coefficients/${id}`);
  return response.data.data;
};
